import React from 'react';

import { Button, Typography } from '@mui/material';
import _ from 'lodash';

import { ReactComponent as ChevronRightIconSmallGray } from '../../../../common/assets/icons/chevron_right_icon_small_gray.svg';
import { SelectableCode } from '../../../../common/types/Codes';

type CodeExtraInfoProps = {
  code: SelectableCode;
  onClick: () => void;
};

export const SelectModifiersButton: React.FC<CodeExtraInfoProps> = ({
  code,
  onClick,
}) => {
  return (
    <Button
      sx={{
        borderRadius: '40px',
        borderStyle: 'none',
        display: 'flex',
        alignItems: 'flex-start',
      }}
      onClick={() => onClick()}
      color={'appGray'}
      variant={'text'}
      endIcon={<ChevronRightIconSmallGray />}
    >
      <Typography
        fontWeight={700}
        fontSize={15}
        color='rgba(38, 96, 113, 1)'
        style={{
          marginRight: '8px',
        }}
      >
        Modifiers
      </Typography>
      {_.isEmpty(code.modifiers) ? (
        <Typography color='rgba(82, 86, 98, 0.60)' fontWeight={700}>
          None
        </Typography>
      ) : (
        <Typography
          color='primary.main'
          fontWeight={700}
          sx={{
            wordWrap: 'break-word',
            whiteSpace: 'normal',
            overflowWrap: 'break-word',
          }}
        >
          {code.modifiers.join('; ')}
        </Typography>
      )}
    </Button>
  );
};
